exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatfile-active .swal2-container {\n  z-index: 999999 !important;\n}\n.active-stage .sc-pNWxx::after {\n  content: \"(Note: If linking to Vista customers, make sure the Vista Customer number mentioned is accurate to avoid mismatching of customers between Followup & Vista)\";\n  font-size: 14px !important;\n  color: rgb(102, 125, 141);\n  margin-left: 5px !important;\n}\n", ""]);

// exports
